@if (form) {
<form [formGroup]="form" (ngSubmit)="register()" nz-row nzGutter="24">
  <un-input
    type="text"
    formControlName="firstName"
    label="First name"
    i18n-label="@@firstName"
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="12"
    nzLg="12"
    nzXl="12"
  ></un-input>
  <un-input
    type="text"
    formControlName="lastName"
    label="Last name"
    i18n-label="@@lastName"
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="12"
    nzLg="12"
    nzXl="12"
  ></un-input>
  @if (showOrganisation) {
  <un-input
    type="text"
    formControlName="organisationName"
    label="Organisation name"
    i18n-label
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="24"
    nzLg="24"
    nzXl="24"
  ></un-input>
  } @if (showOrganisation && !category) {
  <un-input
    type="select"
    [options]="types"
    formControlName="organisationCategory"
    label="Organisation Type"
    i18n-label
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="12"
    nzLg="12"
    nzXl="12"
  ></un-input>
  }
  <un-input
    type="email"
    formControlName="email"
    label="Email"
    i18n-label="@@email"
    nz-col
    nzXs="24"
    nzSm="24"
    [nzMd]="showOrganisation && category ? 24 : 12"
    [nzLg]="showOrganisation && category ? 24 : 12"
    [nzXl]="showOrganisation && category ? 24 : 12"
  ></un-input>
  @if (!showOrganisation) {
  <un-input
    type="tel"
    formControlName="phone"
    [autoComplete]="countrySvc.phoneAutoComplete"
    label="Phone"
    i18n-label
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="12"
    nzLg="12"
    nzXl="12"
  ></un-input>
  }
  <un-input
    type="password"
    formControlName="password"
    label="Password"
    i18n-label="@@password"
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="12"
    nzLg="12"
    nzXl="12"
  ></un-input>
  <un-input
    type="password"
    formControlName="confirmPassword"
    label="Confirm Password"
    i18n-label="@@confirmPassword"
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="12"
    nzLg="12"
    nzXl="12"
  ></un-input>

  <re-captcha
    class="m-b-12 m-t-12"
    (resolved)="resolveRecaptcha($event)"
    [siteKey]="recaptchaKey"
  ></re-captcha>

  <label>
    <input type="checkbox" formControlName="agreeToTerms" />
    <span i18n="@@agreeToTerms">
      I agree to the
      <a class="c-primary" [routerLink]="termsLink">Terms & Conditions</a> and
      <a class="c-primary" [routerLink]="policyLink">Privacy Statement</a>
    </span>
  </label>

  <button class="primary large t-large" type="submit" i18n>Register</button>
</form>
}

<div class="register">
  <span i18n="@@alreadyAStudent">Aleady a student? </span>
  <a
    class="c-primary"
    [routerLink]="loginLink"
    queryParamsHandling="merge"
    i18n="@@signIn"
    (click)="modalRef?.close({ signIn: true })"
    >Sign In</a
  >
</div>
<div class="d-flex social-auth">
  <a (click)="oauth('google')" class="btn btn-plain"
    ><span i18n>Sign up with google</span> <fa-icon [icon]="faGoogle"></fa-icon
  ></a>
  <!-- <a (click)="oauth('facebook')"><fa-icon [icon]="faFacebook"></fa-icon></a> -->
</div>
